<template>
    <div class="table offer-info">
        <div v-for="round in rounds" v-if="round.ssrRoundSupplierCapacities.length>0 || round.supplierCapacityFiles.length >0">
            <div>Round {{round.roundNumber}}
                <!--下载本轮次Excel-->
                <el-button type="primary" @click="offerDownload(round.ttSsrRoundId)">{{$t('ssrManage.offerDownload')}}</el-button>
            </div>
            <capacity-table :round-id="round.ttSsrRoundId" :files="round.supplierCapacityFiles" :suppliers="round.ssrRoundSuppliers" type="capacityAnalysis" :template="round.capacityTemplate" :can-edit="canEdit" :data="round.ssrRoundSupplierCapacities"></capacity-table>
        </div>
        <!--底部操作按钮-->
        <el-row type="flex" justify="center" style="padding-top: 15px;">
            <el-button v-if="roundIds.length>1" type="primary" @click="offerDownload(roundIds)">Download All</el-button>
            <el-button v-if="roundIds.length>1" type="primary" @click="downloadFile()">Download All File</el-button>
        </el-row>
    </div>
</template>
<script>
    import router from '../../../router';
    import {apiService} from "@/api/ssr-manage/ssr-manage";
    import {Message} from "element-ui";
    import commonMethods from "@/utils/commonMethods";
    import CapacityTable from "@/components/page/ssr-manage/capacity-table";

    export default {
        name: '',
        extends: commonMethods,
        components: {CapacityTable},
        props: {
            rounds: Array
        },
        computed: {
            canEdit() {
                return false;
            },
            roundIds() {
                return this.rounds.filter(round=>round.ssrRoundSupplierCosts.length>0).map(round=>round.ttSsrRoundId)
            }
        },
        data() {
            return {
            }
        },
        created() {
        },
        methods: {
            offerDownload(roundIds){
                apiService.exportCapacity(roundIds);
            },
            downloadFile(){
                apiService.downloadAllSupplierCapacityFile(this.rounds[0].ttSsrId);
            },
        }
    }
</script>
<style scoped>
</style>
